export default "__VITE_ASSET__b0341115__"